
/* eslint-disable class-methods-use-this */
/* eslint-disable no-new-wrappers */

const sendDataLayer = (object) => {
    window.dataLayer.push(object);
};

class GTM {
    sendProductImpression(products) {
        const dl = {
            event: 'view_item_list',
            ecommerce: {
                items: [...products.product],
            },
        };

        sendDataLayer(dl);
    }

    sendSearchResults(searchTerm) {
        const dl = {
            event: 'view_search_results',
            search_term: searchTerm,
        };

        sendDataLayer(dl);
    }

    trackProductImpression(products) {
        if (products.product[0].item_list_name === 'search-list'
        || products.product[0].item_list_name === 'category-list') {
            let isCreatedData = false;

            window.dataLayer.forEach((ecommerceObj) => {
                if (ecommerceObj.ecommerce) {
                    if (ecommerceObj.ecommerce.items) {
                        // eslint-disable-next-line no-param-reassign
                        ecommerceObj.ecommerce.items = [...products.product];
                        isCreatedData = true;
                    }
                }
            });

            if (!isCreatedData) {
                this.sendProductImpression(products);
            }
        } else {
            this.sendProductImpression(products);
        }
    }

    trackProductDetail(product) {
        const dl = {
            event: 'view_item',
            ecommerce: {
                items: [product],
            },
        };

        sendDataLayer(dl);
    }

    updateTrackProductDetail(prodObj) {
        window.dataLayer.forEach((ecommerceObj) => {
            if (ecommerceObj.ecommerce) {
                if (ecommerceObj.ecommerce.detail) {
                    // eslint-disable-next-line no-param-reassign
                    ecommerceObj.ecommerce.detail.items = prodObj;
                }
            }
        });
    }

    trackQuickViewClickProduct(kindEvent, product) {
        const dl = {
            event: kindEvent, // ex: productQuickViewClick, promotionClick
            ecommerce: {
                click: {
                    actionField: { list: product.category },
                    items: [...product.product],
                },
            },
        };

        sendDataLayer(dl);
    }

    trackClickedProduct(product, productUrl) {
        const dl = {
            event: 'select_item',
            ecommerce: {
                items: [...product],
            },
            eventCallback: () => {
                document.location = productUrl;
            },
        };

        sendDataLayer(dl);
    }

    // track some event in some option
    trackEventOption(kindEvent, option) {
        const dl = {
            event: `${kindEvent} ${option.labelText}`,
            selectedElement: option.elementTarget,
        };

        sendDataLayer(dl);
    }

    trackAddProductToCart(products) {
        const dl = {
            event: 'add_to_cart',
            ecommerce: {
                items: products,
            },
        };

        sendDataLayer(dl);
    }

    trackDeleteProductToCart(prod) {
        const dl = {
            event: 'remove_from_cart',
            ecommerce: {
                remove: {
                    items: prod,
                },
            },
        };

        sendDataLayer(dl);
    }

    trackShowCart(products) {
        const dl = {
            event: 'view_cart',
            ecommerce: {
                items: products,
            },
        };

        sendDataLayer(dl);
    }

    trackCheckoutStep(actionField, event) {
        const dl = {
            event,
            ecommerce: actionField,
        };

        sendDataLayer(dl);
    }

    trackCheckoutSuccess(order) {
        const products = [...order.products];
        const dl = {
            event: 'purchase',
            ecommerce: {
                ...order.successData,
                items: products,
            },
        };

        sendDataLayer(dl);
    }

    triggerSendDataLayer(obj) {
        sendDataLayer(obj);
    }
}

module.exports = new GTM();
